import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { MsalProvider } from '@azure/msal-react'
import { msalInstance } from './lib/msalConfig'
import { initSentry, Sentry } from './lib/sentry'
import {
  clearStaleChunkReloadFlag,
  installVitePreloadErrorHandler,
  isChunkLoadError,
  reloadOnceForStaleChunk,
} from './lib/staleChunkReload'
import './index.css'
import App from './App.jsx'

initSentry()
installVitePreloadErrorHandler()
clearStaleChunkReloadFlag()

function SentryFallback({ error, resetError }) {
  if (isChunkLoadError(error) && reloadOnceForStaleChunk()) {
    return (
      <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: '24px', background: 'var(--surface)' }}>
        <div className="form-card" style={{ maxWidth: '420px', textAlign: 'center' }}>
          <div style={{ fontSize: '18px', fontWeight: 700, color: 'var(--ink)' }}>กำลังอัปเดตเวอร์ชันใหม่</div>
          <div style={{ fontSize: '13px', color: 'var(--text2)', marginTop: '8px' }}>
            พบไฟล์เก่าหลัง deploy — กำลังรีโหลดหน้า...
          </div>
        </div>
      </div>
    )
  }

  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: '24px', background: 'var(--surface)' }}>
      <div className="form-card" style={{ maxWidth: '420px', textAlign: 'center' }}>
        <div style={{ fontSize: '18px', fontWeight: 700, color: 'var(--ink)' }}>เกิดข้อผิดพลาด</div>
        <div style={{ fontSize: '13px', color: 'var(--text2)', marginTop: '8px' }}>
          ระบบพบปัญหาชั่วคราว กรุณารีเฟรชหน้าเว็บหรือติดต่อ IT
        </div>
        {typeof resetError === 'function' && (
          <button type="button" className="btn btn-primary" style={{ marginTop: '16px' }} onClick={resetError}>
            ลองอีกครั้ง
          </button>
        )}
      </div>
    </div>
  )
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={SentryFallback}>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>,
)
